/* eslint-disable no-unused-vars */
// import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { hideLoading, showLoading } from 'react-redux-loading-bar'
import { AuthFail } from 'src/store/Auth/reducer'
// import store from '../store/store';

// const dispatch =
//
const API_URL = `${process.env.REACT_APP_APIURL}/api/v1`
const API_URL_V2 = `${process.env.REACT_APP_APIURL}/api/v2`

const axiosApi = axios.create({
    baseURL: API_URL,
})

const axiosApiV2 = axios.create({
    baseURL: API_URL_V2,
})

axiosApi.interceptors.request.use(async (config) => {
    const store = await import('../store/store').then(async (res) => await res?.default)

    // loadingShow()
    store.dispatch(showLoading())
    config.headers.Authorization = `Bearer ${localStorage.getItem('userAccessToken')}`
    return config
})

axiosApiV2.interceptors.request.use(async (config) => {
    const store = await import('../store/store').then(async (res) => await res?.default)
    store.dispatch(showLoading())
    config.headers.Authorization = `Bearer ${localStorage.getItem('userAccessToken')}`
    return config
})

const setupResponseInterceptor = (axiosInstance) => {
    axiosInstance.interceptors.response.use(
        async (response) => {
            const store = await import('src/store/store').then(async (res) => await res?.default)
            store.dispatch(hideLoading())
            return response
        },
        async (error) => {
            const store = await import('src/store/store').then(async (res) => await res?.default)
            if (error.response?.status === 403) {
                store.dispatch(AuthFail())
                localStorage.removeItem('userAccessToken')
                localStorage.removeItem('userRefreshToken')
                localStorage.removeItem('userData')
            }
            store.dispatch(hideLoading())
            return Promise.reject(error)
        }
    )
}

setupResponseInterceptor(axiosApi)
setupResponseInterceptor(axiosApiV2)


export async function get(url, params, config = {}) {
    return await axiosApi.get(url, { params, ...config }).then((response) => response.data)
}

export async function post(url, data, config = {}) {
    return axiosApi.post(url, data, { ...config }).then((response) => response.data)
}

export async function put(url, data, config = {}) {
    return axiosApi.put(url, { ...data }, { ...config }).then((response) => response.data)
}
export async function patch(url, data, config = {}) {
    return axiosApi.patch(url, data, { ...config }).then((response) => response.data)
}

export async function del(url, config = {}) {
    return await axiosApi.delete(url, { ...config }).then((response) => response.data)
}

export async function putV2(url, data, config = {}) {
    return axiosApiV2.put(url, data, { ...config }).then((response) => response.data)
}

export async function getV2Blob(url, params, config = {}) {
    return await axiosApiV2.get(url, { 
        params, 
        ...config,
        responseType: 'blob'
    }).then((response) => response.data)
}